import { gql } from '@apollo/client';

export const RELEASE_VISUAL_MUTATION = gql`
  mutation ReleaseVisual($id: Int!) {
    p {
      releaseVisual(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
